<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 to-black text-white p-4">
    <div class="w-full max-w-md bg-gray-800 bg-opacity-95 p-10 rounded-2xl shadow-2xl border border-gray-800 backdrop-blur-lg text-center">
      <img src="@/assets/logo.svg" alt="Syniac Logo" class="w-32 mx-auto mb-4" />
      <h2 class="text-3xl font-extrabold text-blue-400 mb-4">Email Verification</h2>

      <div v-if="loading" class="text-gray-300">Verifying your email...</div>

      <div v-else>
        <p v-if="success" class="text-green-400">{{ message }}</p>
        <p v-else class="text-red-400">{{ message }}</p>
        <router-link v-if="success" to="/login" class="mt-6 inline-block text-blue-400 hover:underline">Go to Login</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "VerifyEmail",
  data() {
    return {
      loading: true,
      success: false,
      message: ''
    };
  },
  async created() {
    const token = this.$route.query.token;
    if (!token) {
      this.message = 'Invalid verification link.';
      this.loading = false;
      return;
    }

    try {
      const response = await axios.get(`https://api.syniac.com:3000/api/auth/verify-email?token=${token}`);
      this.message = response.data || 'Email verified successfully!';
      this.success = true;
    } catch (error) {
      console.error(error);
      this.message = error.response?.data || 'Failed to verify email. The link may have expired.';
      this.success = false;
    } finally {
      this.loading = false;
    }
  }
};
</script>
